export default __webpack_public_path__ + "static/media/ru-store.51b4be7d.svg";